import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import { GroupItem, Item, Label, Form } from "devextreme-react/form";
import { dataGridErrorHandling, showError } from '../../utils/errorHandling';
import { useAssistitiPatologiaInfettivaDataSource } from '../../datasources/AssistitiPatologiaInfettivaDataSource';
import { useScreenSize } from '../../utils/media-query';
import { useNazioniDataSource } from '../../datasources/NazioniDataSource';
import { useRegioniDataSource } from '../../datasources/RegioniDataSource';
import { useComuniDataSource } from '../../datasources/ComuniDataSource';
import { useProvinceDataSource } from '../../datasources/ProvinceDataSource';

export interface ILocation {
  nazioneId?: string;
  regioneId?: string;
  provinciaId?: string;
  comuneId?: string;
  regione?: string;
  provincia?: string;
  comune?: string;
}


type ValueChangedArgs = ILocation;


type Props = {
  data: ILocation;
  onValueChanged?: (e: ValueChangedArgs) => void;
  readOnly?: boolean;
};

export type ComuneSelectorHandle = {
}

const ComuneSelector: React.ForwardRefRenderFunction<ComuneSelectorHandle, Props> = (props, ref) => {
  var [data, setData] = useState<ILocation>(props.data);

  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(props.data)) {
      //console.log("ComuneSelector useEffect", props.data);
      setData(props.data);
    }
  }
    , [props.data]);


  var nazioniDataSource = useNazioniDataSource();
  var regioniDataSource = useRegioniDataSource(data.nazioneId);
  var provinceDataSource = useProvinceDataSource(data.nazioneId, data.regioneId);
  var comuniDataSource = useComuniDataSource(data.nazioneId, data.regioneId, data.provinciaId);

  function form_FieldDataChanged(e: any) {
    try {
      var updatedData: any = {
        ...data,
        [e.dataField]: e.value,
        comune: e.component.getEditor((data.nazioneId === "ITA") ? "comuneId" : "comune")?.option("text"),
        provincia: e.component.getEditor((data.nazioneId === "ITA") ? "provinciaId" : "provincia")?.option("text"),
        regione: e.component.getEditor((data.nazioneId === "ITA") ? "regioneId" : "regione")?.option("text"),
      };


      if (e.dataField === "nazioneId") {
        updatedData.regioneId = undefined;
        updatedData.provinciaId = undefined;
        updatedData.comuneId = undefined;
        updatedData.regione = undefined;
        updatedData.provincia = undefined;
        updatedData.comune = undefined;
      }
      if (e.dataField === "regioneId") {
        updatedData.provinciaId = undefined;
        updatedData.comuneId = undefined;
        updatedData.provincia = undefined;
        updatedData.comune = undefined;
      }
      if (e.dataField === "provinciaId") {
        updatedData.comuneId = undefined;
        updatedData.comune = undefined;
      }

      setData(updatedData);
      props.onValueChanged?.(updatedData);
    }
    catch (error) {
      console.log(error);
    }
  }

  function editorTypeSelector() {
    if (data.nazioneId === "ITA") {
      return 'dxLookup';
    }
    else {
      return 'dxTextBox';
    }
  }

  return (
    <Form colCount={4} formData={data} labelMode='floating' onFieldDataChanged={form_FieldDataChanged} readOnly={props.readOnly} >
      <Item dataField="nazioneId" editorType='dxLookup' isRequired={false} editorOptions={{ dataSource: nazioniDataSource, displayExpr: 'descrizione', valueExpr: 'id' }} >
        <Label text="Nazione" />
      </Item>
      <Item dataField={(data.nazioneId === "ITA") ? "regioneId" : "regione"} editorType={editorTypeSelector()} isRequired={false} editorOptions={{ dataSource: regioniDataSource, displayExpr: 'descrizione', valueExpr: 'id' }} >
        <Label text="Regione" />
      </Item>
      <Item dataField={(data.nazioneId === "ITA") ? "provinciaId" : "provincia"} editorType={editorTypeSelector()} isRequired={false} editorOptions={{ dataSource: provinceDataSource, displayExpr: 'descrizione', valueExpr: 'id' }} >
        <Label text="Provincia" />
      </Item>
      <Item dataField={(data.nazioneId === "ITA") ? "comuneId" : "comune"} editorType={editorTypeSelector()} isRequired={false} editorOptions={{ dataSource: comuniDataSource, displayExpr: 'descrizione', valueExpr: 'id' }} >
        <Label text="Comune" />
      </Item>
    </Form>
  );
}

export default React.forwardRef(ComuneSelector);